import { Contratos } from "../class/contratos";
export default {
    getContratos(context, id) {
        Contratos.byID(id)
            .then(row => {
                context.commit("setContrato", row);
                this.$store.dispatch("getCliente", row.cliente.cliente_id);
            })
            .catch(err => console.error(err));
    },
    getCliente(context, id) {
        Contratos.byID(id)
            .then(row => context.commit("setCliente", row))
            .catch(err => console.error(err));
    }
};
